import { useFetchPage } from "~/core/composables/useFetchPage";
import { SearchMode, useSearch } from "~/core/composables/useSearch";
import { useSort } from "~/core/composables/useSort";
import type { UseFetchParameters } from "~/core/models/UseFetchParameters.type";
import type { UseFetchResponse } from "~/core/models/UseFetchResponse.interface";
import type { Interface } from "~/modules/applicationManagement/models/Interface.interface";
import ApplicationMgtService from "~/modules/applicationManagement/services/applicationMgt.service";
import { Filters, type FiltersSelection, FiltersType } from "~/types";

export function useFetchAppInterface({
  organizationCode,
}: UseFetchParameters): UseFetchResponse<Interface> {
  const service = ApplicationMgtService.getAppInterfaces.bind(
    ApplicationMgtService,
  );

  // To be completed with other filters when they are defined
  const appliedFilters: FiltersSelection = new Map([
    [Filters.NAME, { key: "name", operator: "=like=", value: "" }],
  ]);

  const { searchParams, filters, setFilter, search, onSearch } = useSearch(
    FiltersType.RSQL,
    appliedFilters,
    SearchMode.URL_SEARCH,
  );
  const { sort, onSortChange } = useSort();
  const { isLoading, results, error, fetchData } = useFetchPage({
    organizationCode,
    service,
    searchParams,
    sort,
    useQueryParametersForPagination: true,
  });

  return {
    isLoading,
    results,
    error,
    filters,
    fetchData,
    setFilter,
    onSortChange,
    search,
    onSearch,
  };
}
